module.exports = __webpack_public_path__ + "assets/_logo.5629d21c.svg";